import React from 'react';
import PropTypes from 'prop-types';
// Importar iconos individualmente desde 'react-icons/fa'
import {
  FaBold,
  FaItalic,
  FaUnderline,
  FaStrikethrough,
  FaLink,
  FaUnlink,
  FaAlignLeft,
  FaAlignCenter,
  FaAlignRight,
  FaAlignJustify,
  FaListUl,
  FaListOl,
  FaQuoteLeft,
  FaRulerHorizontal,
  FaParagraph,
  FaPalette,
  FaEraser,
  FaUndo,
  FaRedo,
  FaRemoveFormat
} from 'react-icons/fa'; // Corregido: Usar 'react-icons/fa'

import '../../styles/admin/TiptapToolbar.css'; // Crearemos este archivo

// Componente de botón reutilizable para la barra
const ToolbarButton = ({ onClick, isActive, children, title, disabled }) => (
  <button
    onClick={onClick}
    className={`toolbar-button ${isActive ? 'is-active' : ''}`}
    type="button" // Importante para que no envíe el formulario
    title={title} // Tooltip
    disabled={disabled} // Pasar prop disabled
  >
    {children}
  </button>
);

ToolbarButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  isActive: PropTypes.bool,
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  disabled: PropTypes.bool, // Añadir prop type
};

// Barra de herramientas principal
function TiptapToolbar({ editor }) {
  if (!editor) {
    return null;
  }

  // Función para manejar el enlace (añadir/editar)
  const setLink = () => {
    const previousUrl = editor.getAttributes('link').href;
    const url = window.prompt('URL', previousUrl);

    // Si se cancela o la URL está vacía, quitar el enlace
    if (url === null || url === '') {
      editor.chain().focus().extendMarkRange('link').unsetLink().run();
      return;
    }

    // Añadir o actualizar el enlace
    editor.chain().focus().extendMarkRange('link').setLink({ href: url }).run();
  };

  return (
    <div className="tiptap-toolbar">
      {/* --- Bloques Básicos --- */}
       <ToolbarButton onClick={() => editor.chain().focus().toggleHeading({ level: 1 }).run()} isActive={editor.isActive('heading', { level: 1 })} title="Título 1">H1</ToolbarButton>
       <ToolbarButton onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()} isActive={editor.isActive('heading', { level: 2 })} title="Título 2">H2</ToolbarButton>
       <ToolbarButton onClick={() => editor.chain().focus().toggleHeading({ level: 3 }).run()} isActive={editor.isActive('heading', { level: 3 })} title="Título 3">H3</ToolbarButton>
       <ToolbarButton onClick={() => editor.chain().focus().setParagraph().run()} isActive={editor.isActive('paragraph')} title="Párrafo"><FaParagraph /></ToolbarButton>
       <ToolbarButton onClick={() => editor.chain().focus().toggleBulletList().run()} isActive={editor.isActive('bulletList')} title="Lista Viñetas"><FaListUl /></ToolbarButton>
       <ToolbarButton onClick={() => editor.chain().focus().toggleOrderedList().run()} isActive={editor.isActive('orderedList')} title="Lista Numerada"><FaListOl /></ToolbarButton>
       <ToolbarButton onClick={() => editor.chain().focus().toggleBlockquote().run()} isActive={editor.isActive('blockquote')} title="Cita"><FaQuoteLeft /></ToolbarButton>
       <ToolbarButton onClick={() => editor.chain().focus().setHorizontalRule().run()} title="Línea Horizontal"><FaRulerHorizontal /></ToolbarButton>
       
      <span className="toolbar-separator">|</span>
      
      {/* --- Estilos Inline --- */}
       <ToolbarButton onClick={() => editor.chain().focus().toggleBold().run()} isActive={editor.isActive('bold')} title="Negrita"><FaBold /></ToolbarButton>
       <ToolbarButton onClick={() => editor.chain().focus().toggleItalic().run()} isActive={editor.isActive('italic')} title="Cursiva"><FaItalic /></ToolbarButton>
       <ToolbarButton onClick={() => editor.chain().focus().toggleUnderline().run()} isActive={editor.isActive('underline')} title="Subrayado"><FaUnderline /></ToolbarButton>
       <ToolbarButton onClick={() => editor.chain().focus().toggleStrike().run()} isActive={editor.isActive('strike')} title="Tachado"><FaStrikethrough /></ToolbarButton>
       
      <span className="toolbar-separator">|</span>
      
      {/* --- Enlace --- */}
       <ToolbarButton onClick={setLink} isActive={editor.isActive('link')} title="Enlace"><FaLink /></ToolbarButton>
       <ToolbarButton onClick={() => editor.chain().focus().unsetLink().run()} disabled={!editor.isActive('link')} title="Quitar Enlace"><FaUnlink /></ToolbarButton>
      
      <span className="toolbar-separator">|</span>

      {/* --- Color --- */}
      <div className="toolbar-color-wrapper" title="Color Texto">
        <FaPalette style={{ marginRight: '4px', verticalAlign: 'middle' }} />
        <input
            type="color"
            onInput={event => editor.chain().focus().setColor(event.target.value).run()}
            value={editor.getAttributes('textStyle').color || '#000000'} // Valor por defecto
            data-testid="setColor"
            className="toolbar-color-input"
        />
      </div>
       {/* <ToolbarButton onClick={() => editor.chain().focus().unsetColor().run()} title="Quitar Color"><FaEraser /></ToolbarButton> */} 
      
      <span className="toolbar-separator">|</span>

      {/* --- Alineación --- */}
       <ToolbarButton onClick={() => editor.chain().focus().setTextAlign('left').run()} isActive={editor.isActive({ textAlign: 'left' })} title="Alinear Izquierda"><FaAlignLeft /></ToolbarButton>
       <ToolbarButton onClick={() => editor.chain().focus().setTextAlign('center').run()} isActive={editor.isActive({ textAlign: 'center' })} title="Alinear Centro"><FaAlignCenter /></ToolbarButton>
       <ToolbarButton onClick={() => editor.chain().focus().setTextAlign('right').run()} isActive={editor.isActive({ textAlign: 'right' })} title="Alinear Derecha"><FaAlignRight /></ToolbarButton>
       <ToolbarButton onClick={() => editor.chain().focus().setTextAlign('justify').run()} isActive={editor.isActive({ textAlign: 'justify' })} title="Justificar"><FaAlignJustify /></ToolbarButton>
       <ToolbarButton onClick={() => editor.chain().focus().unsetTextAlign().run()} title="Quitar Alineación"><FaEraser /></ToolbarButton>

      <span className="toolbar-separator">|</span>

      {/* --- Acciones Adicionales --- */} 
      <ToolbarButton onClick={() => editor.chain().focus().unsetAllMarks().run()} title="Limpiar Formato Inline"><FaRemoveFormat /></ToolbarButton>
      <ToolbarButton onClick={() => editor.chain().focus().undo().run()} disabled={!editor.can().undo()} title="Deshacer"><FaUndo /></ToolbarButton>
      <ToolbarButton onClick={() => editor.chain().focus().redo().run()} disabled={!editor.can().redo()} title="Rehacer"><FaRedo /></ToolbarButton>

    </div>
  );
}

TiptapToolbar.propTypes = {
  editor: PropTypes.object, // La instancia del editor de TipTap
};

export default TiptapToolbar; 